import React from "react";

import Box from "@mui/material/Box";

import { QRCodeSVG } from "qrcode.react";

import { QR_ELEMENT_ID } from "../constants";
import { LOGO_BLUE_BASE64 } from "shared/constants/imageAssets";

import { styles } from "./styles";

interface QrCodeProps {
  invoiceUrl: string;
}

const QrCode: React.FC<QrCodeProps> = (props) => {
  const { invoiceUrl } = props;

  return (
    <Box sx={styles.qrContainer}>
      <QRCodeSVG
        id={QR_ELEMENT_ID}
        value={invoiceUrl}
        size={200}
        level="Q"
        bgColor="#FFFFFF"
        marginSize={2.5}
        imageSettings={{
          src: LOGO_BLUE_BASE64,
          width: 50,
          height: 50,
          excavate: true,
        }}
      />
    </Box>
  );
};

export default QrCode;
